import { useState } from "react"
import Input from "../../Input";
import "./style.scss"

const Index = ({ setOpenInventoryModal, isLoading, onUpdate, selectedProduct, setNotification, type = 'inventory' }) => {
    const [quantity, setQuantity] = useState(selectedProduct?.variants[0]?.inventory_quantity);
    const [thermofisherLink, setThermofisherLink] = useState(selectedProduct?.metadata?.thermofisher_link);
    const [error, setError] = useState('');
    
    const handleChange = (e) => {
    let value = e.target.value;

    value = value.replace(/\D/g, '');

    if (value.length < 1 || parseInt(value) > 10000) {
        setError('Quantity must be between 1 to 10000.');
    } else {
        setError('');
    }

    setQuantity(+value);
};

  const isValidURL = (url) => {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[^\s]*)?$/;
    return regex.test(url);
  };

  const handleReferenceBlur = (value) => {
    if (value && !isValidURL(value)) {
      setError("Invalid url")
    } else {
        setError('')
    }
  }


    return (
        <div className="small-modal-wrapper">
            <div className="inventory-modal-content">
                <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
                    <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '0px', top: '0px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
                        setOpenInventoryModal(false)
                    }}></i>
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', color: 'var(--white)' }}
                        className='completed'
                    >
                     {type === 'inventory' ? <i class="fal fa-box-open" ></i> : <i class="fal fa-link" ></i>}
                    </span>
                </div>
                <h2>{type === 'inventory' ? 'Update Quantity' : 'Update Thermofisher Link'}</h2>
                <p>you are about to change the {type === 'inventory' ? 'available quantity' : 'thermofisher link'} of <br/>
                <strong>{selectedProduct?.title} ({selectedProduct?.material ? `${selectedProduct?.mid_code} ${selectedProduct?.material}` : "-"})</strong></p>
                <div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '10px'}}>
                    {type === 'inventory' ?
                    <Input placeholder="Enter Quantity" value={quantity} onChange={handleChange} />
                    :
                    <Input type='text' placeholder={'Enter Thermofisher Product Link'} value={thermofisherLink} onChange={(e) => {
                        setThermofisherLink(e.target.value)
                    }} onBlur={(e) => handleReferenceBlur(e.target.value)} isBlur />
                    }
                    {error && <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>}
                </div>
                <button className='btn completed'
                    disabled={(type === 'inventory' ? !quantity : thermofisherLink !== '' && !isValidURL(thermofisherLink)) || error || isLoading}
                    onClick={() => {
                       onUpdate(type === 'inventory' ? quantity : thermofisherLink)
                    }}>
                    {type === 'inventory' ? 'Update Quantity' : 'Update Link'}
                </button>
                <button className='btn transparent' onClick={() => {
                    setOpenInventoryModal(false)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index